export function isMonitoringProbe(): boolean {
    return typeof navigator != 'undefined' && navigator.userAgent.includes('MSEXCHMON');
}
